module.exports = __webpack_public_path__ + "img/project-crafted.a1f4d3c7.png";